<template>
	<div>

		<v-toolbar flat fixed>
          <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
          <v-toolbar-title class="white--text">Connections</v-toolbar-title>
        </v-toolbar>
		
		<div class="hasToolbar">
			<v-layout row wrap pt-3>
				<v-flex xs10 sm10 md10 form-item>
					<v-text-field prefix="+91" v-model="Form.phoneNumber" placeholder=" " label="Phone Number" type="tel"></v-text-field>
				</v-flex>
				<v-flex xs2 sm2 md2 pr-2>
					<v-btn icon text @click="fn_savePhoneNumber">Save</v-btn>
				</v-flex>
			</v-layout>

			<v-divider v-if="phoneNumbers"></v-divider>

			<v-list nopadding v-if="phoneNumbers">
				<v-subheader>Phone Numbers</v-subheader>
				<v-divider></v-divider>
				<div v-for="(item, index) in phoneNumbers" :key="index">
					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>{{item}}</v-list-tile-title>	
						</v-list-tile-content>

						<v-list-tile-action>
	                      <v-btn color="primary" flat @click="fn_connectPhoneNumber(item)">Connect</v-btn>
	                    </v-list-tile-action>
						
					</v-list-tile>

					<v-divider v-if="phoneNumbers.length-1 != index"></v-divider>
				</div>
				
			</v-list>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				Form:{"phoneNumber":null},
				phoneNumbers:null
			}
		},
		methods:{
			fn_savePhoneNumber: function(){
				var self = this;
		        let postObj = {};
		        this.postData('WebRTCNumber', this.Form, 
		          {
		            onSuccess: function(response){
		              console.log(response);
		              self.Form.phoneNumber = null;
		              self.fn_getPhoneNumbers();
		            },
		            onError: function(error){
		              console.log(error);
		              self.showToast('Something went wrong. Try again!.')
		            }
		        });
			},

			fn_getPhoneNumbers: function(){
				var self = this;
		        this.getData('WebRTCNumber', null, 
		          {
		            onSuccess: function(response){
		              console.log(response);
		              self.phoneNumbers = JSON.parse(response);
		            },
		            onError: function(error){
		              console.log(error);
		              self.showToast('Something went wrong. Try again!.')
		            }
		        });
			},

			fn_connectPhoneNumber: function(phoneNumber){
				var self = this;
		        this.getData('ConnectWebRTC', phoneNumber, 
		          {
		            onSuccess: function(response){
		              console.log(response);
		            },
		            onError: function(error){
		              console.log(error);
		              self.showToast('Something went wrong. Try again!.')
		            }
		        });
			},

			fn_goBack: function(){
                this.$router.go(-1);
            },
		},
		mounted: function(){
            window.js_globals.fn_onBackPress = this.fn_goBack;
            this.fn_getPhoneNumbers();
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/connections.vue